module.exports = __webpack_public_path__ + "img/warning-embargo.2d27aaea.svg";